import React from 'react';
import { connect } from 'react-redux';

import { fetchEmployee, updateEmployee } from '../../store/actions/employee';
import { fetchEmployer } from '../../store/actions/employer';
import { fetchOffices } from '../../store/actions/office';
import { fetchDepartments } from '../../store/actions/department';
import EditEmployee from '../../components/EditEmployee/EditEmployee';

class Employee extends React.Component {
  componentDidMount() {
    this.props.onFetchEmployee(this.props.match.params.id);
    this.props.onFetchEmployer(this.props.companyCode);
    this.props.onFetchOffices();
    this.props.onFetchDepartments();
  }

  render() {
    const {
      data, onUpdateEmployee, departments, offices, loading,
    } = this.props;

    return (
      <EditEmployee
        data={data}
        UpdateEmployee={onUpdateEmployee}
        departments={departments}
        offices={offices}
        loading={loading}
        title="Editar"
        subTitle="Atualize os dados do funcionário"
      />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  data: state.employee.data,
  offices: state.office.offices,
  departments: state.department.departments,
  companyCode: state.auth.companyCode,
});

const mapDispatchToProps = dispatch => ({
  onUpdateEmployee: data => dispatch(updateEmployee(data)),
  onFetchEmployee: id => dispatch(fetchEmployee(id)),
  onFetchOffices: () => dispatch(fetchOffices()),
  onFetchDepartments: () => dispatch(fetchDepartments()),
  onFetchEmployer: companyCode => dispatch(fetchEmployer(companyCode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Employee);
